<template>
    <div>
        <a-card :bordered="false" :bodyStyle="tstyle">
            <div class="table-page-search-wrapper" v-if="hasPerm('baDatadictDetail:page')">
                <a-form layout="inline">
                    <a-row :gutter="48">
                        <a-col :md="8" :sm="24">
                            <a-form-item label="姓名">
                                <a-input v-model="queryParam.doctorName" allow-clear placeholder="请输入医生姓名" />
                            </a-form-item>
                        </a-col>
                        <a-col :md="8" :sm="24">
                            <a-form-item label="号源类别">
                                <!-- <a-input v-model="queryParam.useflag" allow-clear placeholder="请输入是否启用（0:禁用，1:启用）" /> -->
                                <a-select v-model="queryParam.treatType" placeholder="请选择号源类别">
                                    <a-select-option value="0">图文问诊</a-select-option>
                                    <a-select-option value="1">健康咨询</a-select-option>
                                    <a-select-option value="2">视频问诊</a-select-option>
                                    <a-select-option value="3">电话咨询</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="8" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-card>
        <a-card :bordered="false">
            <s-table ref="table" :columns="columns" :data="loadData" :alert="options.alert"
                :rowKey="(record) => record.sourceId" :rowSelection="options.rowSelection">



                <span slot="treatType" slot-scope="text, record">
                    {{ record.treatType == '0' ? '图文问诊' : record.treatType == '1' ? '健康咨询' : record.treatType
                    == '2' ? '视频问诊' :  record.treatType  == '3' ? '电话咨询' :'' }}
                </span>
                <span  slot="weekDay" slot-scope="text, record">
                    {{ record.weekDay ? '每'+englishWeek(record.weekDay) : '---' }}  
                    
                </span>
                <span slot="time" slot-scope="text, record">
                    {{ record.time ? record.time : '---' }}
                </span>
                <span  slot="fee" slot-scope="text, record">
                 <span  style="text-align: right;width: 100%; display: inline-block;">{{ Number(record.fee).toFixed(2)  }}  </span>    
                </span>
                <span slot="action" slot-scope="text, record">
                    <a v-if="hasPerm('baDatadictDetail:edit')" @click="showSource(record)">编辑</a>
                    <a-divider type="vertical" v-if="hasPerm('baDatadictDetail:edit') & hasPerm('baDatadictDetail:delete')"/>
                    <a-popconfirm v-if="hasPerm('baDatadictDetail:delete')" placement="topRight" title="确认删除？" @confirm="() => baDatadictDetailDelete(record)">
                    <a>删除</a>
                    </a-popconfirm>

                </span>

            </s-table>
        </a-card>
         <!-- 修改号源弹框 -->
         <a-modal v-model="editSource" :width="600" title="修改号源" :maskClosable="false" @cancel="handleHideSource">
            <template slot="footer">
                <a-button key="back" @click="handleHideSource">
                    取消
                </a-button>
                <a-button key="ok" @click="fn_editSource">
                    修改
                </a-button>
            </template>
            <a-row :gutter="24" style="margin-bottom: 10px;">
                <!-- <a-form-item label="号源类别" :labelCol="{xs: { span: 24 },sm: { span: 4 }}" style="margin-bottom:10px"
              :wrapperCol="{xs: { span: 24 },sm: { span: 14 }}">
              <a-select v-model="treatType" placeholder="请选择号源类别" style="width:160px">
                <a-select-option value="0">复诊开药-图文问诊</a-select-option>
                <a-select-option value="1">健康咨询-图文咨询</a-select-option>
                <a-select-option value="2">复诊开药-视频问诊</a-select-option>
                <a-select-option value="3">健康咨询-电话咨询</a-select-option>
              </a-select>
            </a-form-item> -->
            <a-form-item label="挂号费" :labelCol="{ xs: { span: 24 }, sm: { span: 4 } }" style="margin-bottom:10px;" :wrapperCol="{ xs: { span: 24 }, sm: { span: 20 } }">
                    <a-input style="width:260px" v-model="fee" allow-clear placeholder="请输入挂号费" /> &nbsp;&nbsp; <span style="padding-left: 10px;">元</span> 
                </a-form-item>
                <a-form-item label="号源数量" :labelCol="{ xs: { span: 24 }, sm: { span: 4 } }" style="margin-bottom:10px;" :wrapperCol="{ xs: { span: 24 }, sm: { span: 20 } }">
                    <a-input style="width:260px" v-model="patientCount" allow-clear placeholder="请输入号源数量" /> &nbsp;&nbsp; <span style="padding-left: 10px;">人</span>
                </a-form-item>
           
            </a-row>
        </a-modal>
    </div>
</template>
<script>
import { STable, XDown } from '@/components'
import moment from 'moment'
import { getDoctorServicesPage, updateDoctorService,  deleteDoctorService} from '@/api/modular/interhospital/numSource/numSourceManage'
export default {
    components: {
        STable,
        XDown
    },
    data() {
        return {
            // 高级搜索 展开/关闭
            advanced: false,
            // 查询参数
            queryParam: {},
            // 表头
            columns: [
                {
                    title: '提交时间',
                    align: 'center',
                    dataIndex: 'updateTime'
                },
                {
                    title: '科室',
                    align: 'center',
                    dataIndex: 'deptName'
                },
                {
                    title: '医生姓名',
                    align: 'center',
                    dataIndex: 'doctorName'
                },
                {
                    title: '号源类别',
                    align: 'center',
                    dataIndex: 'treatType',
                    scopedSlots: { customRender: 'treatType' },
                },
                {
                    title: '号源时间',
                    align: 'center',
                    dataIndex: 'weekDay',
                    scopedSlots: {customRender: 'weekDay'}
                },
                {
                    title: '接诊时间',
                    align: 'center',
                    dataIndex: 'time',
                    scopedSlots: {customRender: 'time'}
                },
                {
                    title: '号源数量',
                    align: 'center',
                    dataIndex: 'patientCount',
                },,
                {
                    title: '挂号费',
                    align: 'center',
                    dataIndex: 'fee',
                    scopedSlots: {customRender: 'fee'}
                },
            ],
            tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
            // 加载数据方法 必须为 Promise 对象
            loadData: parameter => {
                return getDoctorServicesPage(Object.assign(parameter, this.switchingDate())).then((res) => {
                    console.log('获取未激活号源',res.data)
                    if(res.data.rows==null || res.data.rows=='' || res.data.rows==undefined){
                        res.data.rows = []
                    }
                    return res.data
                })
            },
            selectedRowKeys: [],
            selectedRows: [],
            options: {
                alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
                rowSelection: {
                    selectedRowKeys: this.selectedRowKeys,
                    onChange: this.onSelectChange
                }
            },
            patientCount: 0, // 号源数量
            treatType: '0', //服务类型 0-图文问诊1-健康咨询2-视频问诊3-电话问诊
            editSource: false, // 编辑坐诊弹框
            fee: 0, //挂号费
            editRecord: {}, // 修改号源数量弹框数据
            
        }
    },
    created() {
        this.columns.push({
            title: '操作',
            width: '150px',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
        })
    },
    methods: {
        moment,
        
        /**
         * 查询参数组装
         */
        switchingDate() {
            const queryParamctstamp = this.queryParam.ctstampDate
            if (queryParamctstamp != null) {
                this.queryParam.ctstamp = moment(queryParamctstamp).format('YYYY-MM-DD')
                if (queryParamctstamp.length < 1) {
                    delete this.queryParam.ctstamp
                }
            }
            // const queryParamutreatType = this.queryParam.treatType
            // if (queryParamutreatType != null) {
            //     this.queryParam.treatType = Number(this.queryParam.treatType)
            //     if (queryParamutreatType.length < 1) {
            //         delete this.queryParam.treatType
            //     }
            // }
            const obj = JSON.parse(JSON.stringify(this.queryParam))
            return obj
        },
        onChangectstamp(date, dateString) {
            this.ctstampDateString = dateString
        },
        onChangeutstamp(date, dateString) {
            this.queryParam.startDate = dateString[0];
            this.queryParam.endDate = dateString[1];

        },
        fn_editSource() {
            console.log('选择的类型为',this.treatType)
            if(this.patientCount == null || this.patientCount == undefined || this.patientCount == ''){
                this.$message.warning('请输入号源数量');
                return
            }
            if(this.fee == null || this.fee == undefined || this.fee == ''){
                this.$message.warning('请输入挂号费');
                return
            }
            let params = {
                treatId : this.editRecord.treatId, //医生开通的服务id
                treatDetailId : this.editRecord.treatDetailId, //医生开通的服务详情id
                treatType: this.treatType, //服务类型 0-图文问诊1-健康咨询2-视频问诊3-电话问诊
                patientCount : this.patientCount, // 号源数量
                fee : this.fee //挂号费
            }
            updateDoctorService(params).then(res => {
                console.log(res)
                if (res.code == 200) {
                    this.$message.success('修改成功');
                    this.editSource = false;
                    this.handleOk();
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        showSource(record) {
            this.editSource = true;
            this.editRecord = record;
            this.treatType = (record.treatType).toString()
            this.patientCount = record.patientCount; // 号源数量
            this.fee = record.fee
        },
        handleHideSource() {
            this.editSource = false;
        },
        baDatadictDetailDelete (record) {
            deleteDoctorService({ treatId: record.treatId,treatDetailId: record.treatDetailId, treatType: record.treatType }).then((res) => {
            if (res.success) {
                this.$message.success('删除成功')
                this.handleOk();
            } else {
                this.$message.error('删除失败：' + res.message)
            }
            }).catch((err) => {
            this.$message.error('删除错误：' + err.message)
            }).finally((res) => {

            })
        },
        handleOk() {
            this.$refs.table.refresh()
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys
            this.selectedRows = selectedRows
        },
        englishWeek(days) {
            let day = Number(days);
            switch (day) { 
            case 7:
                return '周日'
                break;
            case 1:
                return '周一'
                break;
            case 2:
                return '周二'
                break;
            case 3:
                return '周三'
                break;
            case 4:
                return '周四'
                break;
            case 5:
                return '周五'
                break;
            case 6:
                return '周六'
                break;
            default:
                return ''
                break;
                
            }
        },
    }
}
</script>
<style lang="less">
.table-operator {
    margin-bottom: 18px;
}

button {
    margin-right: 8px;
}
</style>
